export default "https://cdn-static.gokick.com/assets/4e1d6b599b0c658e33aa5c1b8604da35a9a49f05/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";